var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTripAdvisor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#BE3538;}\n\t.st2{fill:#589442;}\n\t.st3{fill:#FFD881;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M57.44,264.18c4.63,12.49,18.52,18.8,31.01,14.31c12.49-4.63,18.8-18.52,14.17-31.01 c-4.63-12.49-18.52-18.8-31.01-14.31C59.26,237.8,52.95,251.69,57.44,264.18z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_4_",
    className: "st0",
    cx: 26.71,
    cy: 255.76,
    r: 24.13
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st1",
    d: "M30.78,255.48c0,2.53-1.96,4.49-4.49,4.49c-2.53,0-4.49-1.96-4.49-4.49 c0-2.39,1.96-4.49,4.49-4.49C28.81,250.99,30.78,253.09,30.78,255.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st2",
    d: "M84.52,255.48c0,2.53-1.96,4.49-4.49,4.49c-2.53,0-4.49-1.96-4.49-4.49 c0-2.39,1.96-4.49,4.49-4.49C82.55,250.99,84.52,253.09,84.52,255.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    d: "M13.1,255.48c0,7.3,5.89,13.19,13.19,13.19c7.3,0,13.19-5.89,13.19-13.19s-5.89-13.19-13.19-13.19 C19.13,242.29,13.1,248.18,13.1,255.48z M17.73,255.48c0-4.77,3.93-8.7,8.7-8.7c4.77,0,8.7,3.93,8.7,8.7c0,4.77-3.93,8.7-8.7,8.7 S17.73,260.25,17.73,255.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    d: "M66.84,255.48c0,7.3,5.89,13.19,13.19,13.19s13.19-5.89,13.19-13.19s-5.89-13.19-13.19-13.19 C72.73,242.29,66.84,248.18,66.84,255.48z M71.33,255.48c0-4.77,3.93-8.7,8.7-8.7c4.77,0,8.7,3.93,8.7,8.7c0,4.77-3.93,8.7-8.7,8.7 C75.26,264.18,71.33,260.25,71.33,255.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st3",
    d: "M70.77,230.64c2.81-0.98,5.61-1.54,8.42-1.54c-7.72-3.51-16.42-5.19-25.96-5.19 s-18.38,1.82-26.1,5.05c13.89,0.28,25.12,11.08,26.1,24.84c0.28-3.09,0.98-6.31,2.39-9.26C58.7,238.08,64.17,233.17,70.77,230.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "M101.64,239.9c1.26-5.33,5.19-10.8,5.19-10.8H89.01c-9.96-6.45-22.17-9.96-35.64-9.96 c-14.03,0-26.66,3.51-36.62,10.1H0.05c0,0,3.93,5.33,5.19,10.66c-3.23,4.49-5.19,9.82-5.19,15.86c0,14.73,12.07,26.8,26.8,26.8 c8.42,0,16-3.93,20.91-10.1l5.75,8.56l5.75-8.56c2.53,3.23,5.89,5.89,9.82,7.72c6.45,2.95,13.75,3.23,20.49,0.84 c13.89-5.19,20.91-20.63,15.86-34.38C104.3,244.11,103.04,241.87,101.64,239.9z M53.23,223.91c9.68,0,18.38,1.68,25.96,5.19 c-2.81,0.14-5.61,0.56-8.42,1.54c-6.73,2.53-12.07,7.44-15.01,13.89c-1.4,2.95-2.1,6.03-2.39,9.26 c-0.98-13.75-12.21-24.55-26.1-24.84C34.85,225.73,43.69,223.91,53.23,223.91z M44.39,267.69c-3.79,5.61-10.38,9.4-17.68,9.4 c-11.79,0-21.33-9.54-21.33-21.33c0-11.79,9.54-21.33,21.33-21.33s21.33,9.54,21.33,21.33c0,0.7-0.14,1.4-0.28,2.1 C47.48,261.51,46.35,264.88,44.39,267.69z M87.46,275.96c-5.33,1.96-11.22,1.68-16.42-0.7c-3.65-1.68-6.74-4.35-8.84-7.72 c-0.84-1.4-1.68-2.81-2.24-4.35c-0.7-1.82-0.98-3.51-1.12-5.47c-0.42-3.65,0.14-7.44,1.82-10.94c2.39-5.19,6.59-9.12,12.07-11.08 c11.08-4.07,23.43,1.54,27.5,12.63C104.3,259.55,98.55,271.76,87.46,275.96z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st2",
    d: "M384.09,223.49c0,2.81,2.39,5.19,5.19,5.19s5.19-2.39,5.19-5.19s-2.39-5.19-5.19-5.19 C386.33,218.3,384.09,220.68,384.09,223.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    d: "M138.4,223.21l-7.86,2.67c0,0,0,9.4,0,10.24c-0.84,0-8.7,0-8.7,0v6.88c0,0,7.58,0,8.42,0 c0,0.84,0,22.03,0,22.03c0,10.52,3.51,14.73,12.35,14.73c2.25,0,4.35-0.28,6.45-0.84l0.28-0.14l-0.14-7.16l-0.56,0.28 c-1.68,0.56-3.09,0.84-4.07,0.84c-4.07,0-5.61-2.39-5.61-8.56c0,0,0-20.35,0-21.33c0.84,0,9.96,0,9.96,0v-6.88c0,0-9.12,0-9.96,0 c0-0.84,0-13.19,0-13.19L138.4,223.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    d: "M165.62,242.99c0-2.39,0-7.02,0-7.02h-8v42.94h8.7v-21.47c0-8.98,3.79-14.03,10.66-14.03 c0.98,0,1.96,0.14,3.09,0.42l0.56,0.14l0.28-8.42l-3.79-0.28C172.21,235.41,168.14,238.08,165.62,242.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    d: "M227.64,235.13c-6.03,0-10.94,2.81-14.31,8c0-2.1,0-7.02,0-7.02h-8v60.33h8.7c0,0,0-21.05,0-23.43 c3.09,4.21,7.58,6.59,13.19,6.59c10.94,0,18.1-8.98,18.1-23.01C245.46,243.83,238.3,235.13,227.64,235.13z M225.25,272.6 c-6.88,0-11.08-5.89-11.08-15.29c0-9.12,4.49-15.01,11.51-15.01c6.74,0,10.8,5.61,10.8,14.87 C236.34,266.7,231.99,272.6,225.25,272.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st2",
    d: "M270.85,235.13c-5.33,0-9.96,0.98-14.31,3.09l-0.28,0.14l0.14,7.44l0.7-0.42 c4.07-2.25,8-3.51,11.51-3.51c6.31,0,9.96,3.65,9.96,9.96v0.42c-0.7,0-4.91,0-4.91,0c-14.31,0-22.17,5.19-22.17,14.59 c0,7.58,5.75,12.77,13.89,12.77c6.03,0,10.66-2.39,13.89-6.73c0,1.68,0,6.17,0,6.17h7.86v-25.96 C286.85,241.17,281.52,235.13,270.85,235.13z M278.43,260.95c0,7.44-4.49,12.21-11.37,12.21c-4.21,0-7.16-2.81-7.16-6.73 c0-5.19,4.91-8,14.03-8c0,0,3.79,0,4.49,0C278.43,258.99,278.43,260.95,278.43,260.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st2",
    d: "M323.89,215.63c0,0,0,23.85,0,26.24c-3.23-4.49-7.72-6.88-13.47-6.88 c-10.66,0-17.82,8.7-17.82,21.75c0,13.47,7.3,22.73,17.68,22.73c6.17,0,10.94-2.67,14.31-8c0,2.1,0,7.3,0,7.3h8v-63.42h-8.7V215.63 z M312.53,272.46c-6.59,0-10.8-5.75-10.8-15.01s4.21-15.29,10.52-15.29c7.16,0,11.51,5.75,11.51,15.29 C323.89,266.56,319.4,272.46,312.53,272.46z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_31_",
    className: "st2",
    points: "371.46,236.12 359.11,260.81 347.74,236.12 337.92,236.12 358.83,279.05  380.44,236.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_32_",
    className: "st2",
    points: "393.21,236.12 384.93,236.12 384.93,279.05 393.63,279.05 393.63,236.12  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st2",
    d: "M403.87,247.06c0,6.03,4.21,9.26,11.79,12.91c4.77,2.39,7.3,3.79,7.3,7.16 c0,3.37-3.09,5.61-7.86,5.61c-3.37,0-7.16-0.98-10.94-2.81l-0.7-0.28l-0.28,7.58l0.28,0.14c3.51,1.4,7.3,2.1,11.23,2.1 c10.66,0,17.54-5.05,17.54-12.91c0-6.59-4.35-9.82-11.93-13.33c-5.47-2.53-7.86-4.07-7.86-6.88c0-2.67,2.53-4.35,6.59-4.35 c3.65,0,7.16,0.84,10.38,2.39l0.56,0.28l0.42-7.44l-0.28-0.14c-3.65-1.12-7.16-1.54-10.52-1.54 C410.18,235.55,403.87,240.19,403.87,247.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st2",
    d: "M459.43,235.13c-13.05,0-21.19,8.56-21.19,22.45c0,13.89,8.14,22.45,21.19,22.45 c13.19,0,21.33-8.56,21.33-22.45C480.62,243.69,472.48,235.13,459.43,235.13z M459.43,272.88c-7.16,0-12.07-6.17-12.07-15.43 c0-9.26,4.91-15.43,12.07-15.43c7.3,0,12.07,6.03,12.07,15.43S466.73,272.88,459.43,272.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st2",
    d: "M496.76,242.99c0-2.39,0-7.02,0-7.02h-8v42.94h8.7v-21.47c0-8.98,3.79-14.03,10.66-14.03 c0.98,0,1.96,0.14,3.09,0.42l0.56,0.14l0.28-8.42l-3.79-0.28C503.35,235.41,499.28,238.08,496.76,242.99z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_38_",
    points: "196.49,236.12 188.21,236.12 188.21,279.05 196.91,279.05 196.91,236.12  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    d: "M187.37,223.49c0,2.81,2.39,5.19,5.19,5.19s5.19-2.39,5.19-5.19s-2.39-5.19-5.19-5.19 S187.37,220.68,187.37,223.49z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripAdvisor);
export default __webpack_public_path__ + "static/media/tripAdvisor.d1b7085ab0176620c698a4e4a3aaaa19.svg";
export { ForwardRef as ReactComponent };